"use client";
import Link from "next/link";
import styles from "./page.module.css";
import Image from "next/image";
import "./ProjectSample.css";
import { usePathname } from "next/navigation";
import { IProjectSample } from "./interfaces";

export const ProjectSample: React.FC<IProjectSample> = ({
  projectItem,
  filter,
}) => {
  const imgPath = projectItem.coverImage.data.attributes.url;
  const itemTag = projectItem.tag.data.attributes.tag;
  const pathname = usePathname();

  const base64Img =
    "data:image/bmp;base64,Qk32BAAAAAAAADYAAAAoAAAACAAAAAgAAAABABgAAAAAAMAAAAATCwAAEwsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQaACglDTAoP01OO0pNM0VML0NNNEdSPk5WRVNYSFVXbHN5anJ4ZW53Y213ZW96anN9bXZ9b3Z8hoyRhIqRgoiQgYiSg4uViI+Yi5GZjZKYk5mdk5idkpiek5mgl52knaKpoaespKmtmJ6fmJ6gmqCinqOnpKisqq+ysbW3tbq7mJ+dmqCenaOio6eoqq6vsra3ur6+v8TDmJ+bmaCdnqOipKmorLCwtLi4vcG/w8fF";

  return (
    <Link
      href={pathname + "/" + projectItem.slug}
      className={`sample ${itemTag} ${
        !!filter && filter !== itemTag ? "hidden" : ""
      }`}
    >
      <div className={styles.sample__imgContainer}>
        <Image
          height={1000}
          width={1000}
          className={"sample__img"}
          src={`https://api.blwall.com${imgPath}`}
          alt={projectItem.title}
          loading="lazy"
          placeholder="blur"
          blurDataURL={base64Img}
        />
      </div>
      <div className={styles.sample__content}>
        <h6 className={"sample__title"}>{projectItem.title}</h6>
        <span className={styles.sample__subtitle}>{projectItem.subtitle}</span>
      </div>
    </Link>
  );
};
